import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import {
  destroyLenis,
  initLenis,
  refreshScrollTrigger,
} from "../lib/motion";
import "lenis/dist/lenis.css";

/**
 * Boots Lenis once at the app root and refreshes ScrollTrigger on route changes.
 */
export function useLenis(): void {
  const location = useLocation();

  useEffect(() => {
    initLenis();
    return () => {
      destroyLenis();
    };
  }, []);

  useEffect(() => {
    // Allow DOM to settle after route swap, then refresh measurements
    const id = window.setTimeout(() => {
      refreshScrollTrigger();
    }, 200);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.hash]);
}
